var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-border"},[_c('v-row',{staticClass:"border-b"},[_c('v-col',{staticClass:"text-center active-color",attrs:{"cols":"6","md":"3"}},[_c('span',{staticClass:"text-header-step-active"},[_vm._v("Solicitudes")])])],1),_c('div',[_c('div',[_c('ResumenFoliosPorBeneficio'),_c('IndexSolicitudes')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }